var WIDGET_PRIORITY = 0.5;
var Constants = {
  WIDGET_PRIORITY: WIDGET_PRIORITY
};

export { WIDGET_PRIORITY, Constants as default };
